import React from 'react';
import { translate } from '../../../services/translate';
import DangerousHtml from '../../dangerous-html/DangerousHtml';

export default function CmsTranslate(props) {
    return <DangerousHtml content={translate(props.children)} />;
}
